<div class="cv-floating-sketch compact" *ngIf="selectedSketch && selectedSketch.length > 0">
    <div class="sketch-body">
        <div class="floating-sketch-container">
            <div class="collapsable">
                <i class="fas" [ngClass]="{'fa-angle-up': open, 'fa-angle-down': !open }" (click)="openSketch($event)"></i>
            </div>
            <div class="sketch-info">
                <span class="show-sketch">{{(open)? 'Hide': 'Show'}} Floorplan</span>
                <span class="level-name">{{levelName}}</span>
            </div>
            <div class="expandable">
                <i class="fas fa-expand" (click)="expandPhoto($event)"></i>
            </div>
        </div>
        <div *ngIf="open" class="sketch-gallery-container">
            <ng-container *ngFor="let image of selectedSketch">
                <input class="input-chk-selected-sketch" [checked]="isSketchSelected(image)" (change)="onCheckSketch($event, image)" type="checkbox" name="sketch-{{image.id}}">
                <cv-invision-photo-card
                        [info]="image"
                        (openGallery)="openGallery($event)">
                </cv-invision-photo-card>
            </ng-container>
        </div>
    </div>
</div>
